<template>
  <v-chip
    v-on:click="pushToDetail"
    class="font-weight-600 custom-barcode"
    :class="{ 'my-1': !dense, 'cursor-pointer': id, 'cursor-default': !id }"
    :color="color || 'chip-custom-blue'"
    outlined
    label
    :small="small"
  >
    {{ barcode }}
  </v-chip>
</template>

<script>
export default {
  props: {
    barcode: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      required: false,
    },
    dense: {
      type: Boolean,
      required: false,
    },
    route: {
      type: String,
    },
    id: {
      type: Number,
    },
    color: {
      type: String,
      required: false,
    },
  },
  methods: {
    pushToDetail() {
      let detailID = this.lodash.toSafeInteger(this.id);
      if (this.route && detailID > 0) {
        this.$router.push(
          this.getDefaultRoute(this.route, {
            params: { id: detailID },
          })
        );
      }
      this.$emit("page:refress", true);
    },
  },
};
</script>
